<template>
  <div class="trust">
    <div v-if="visible" class="content">
      <p :class="{ 'font-weight-bold': lang === 'ru' }" v-text="translations[lang].title" class="title" />

      <div class="trust__wrapper">
        <div v-for="(item, index) in translations[lang].items" :key="index" class="trust__item">
          <div class="trust__icon">
            <img :alt="item.title" :src="require(`@/assets/img/${item.logo}`)" />
          </div>

          <p :class="{ 'font-weight-medium': lang === 'ru' }" v-text="item.title" class="trust__title" />

          <p v-html="item.description" class="trust__description" />
        </div>
      </div>

      <div class="trust__button" v-if="!hideActionBtn">
        <router-link v-if="lang === 'en'" :to="{ path: '/pricing' }" class="custom-button introductionItem__button btn-news-upload">Upload a floor plan</router-link>
        <button v-if="lang === 'ru'" @click="scrollToShowcase" class="custom-button" v-text="translations[lang].button" />
      </div>
    </div>
  </div>
</template>

<script>
import { smoothScroll } from '@/helpers';

export default {
  name: 'Trust',
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    open: {
      default: () => null,
      type: Function,
    },
    visible: {
      default: false,
      type: Boolean,
    },
    hideActionBtn: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    translations: {
      en: {
        button: 'Try now',
        items: [
          {
            description: '<span>A whole bundle<br /></span> of visuals for $45',
            logo: 'trust/price.svg',
            title: 'Affordable price',
          },
          {
            description: 'Get visuals<br />in <span>24 hours</span>',
            logo: 'trust/speed.svg',
            title: 'High speed',
          },
          {
            description: 'Professional visuals that make your ads <span>stand out</span>',
            logo: 'trust/quality.svg',
            title: 'Quality of visuals',
          },
          {
            description: 'Contact us <span>24/7</span> via chat, messenger or email',
            logo: 'trust/support.svg',
            title: 'Support and care',
          },
        ],
        title: 'Why is Getfloorplan trusted?',
      },
      ru: {
        button: 'Попробовать',
        items: [
          {
            description: 'Пакет материалов<br /> от <span>2 450₽</span>',
            logo: 'icons/save_rub.svg',
            title: 'Доступная цена',
          },
          {
            description: 'Обработка более 500 <br />планировок <span>за 24 часа</span>',
            logo: 'trust/speed.svg',
            title: 'Высокая скорость',
          },
          {
            description: 'Визуализации <span>в высоком<br/>разрешении</span>',
            logo: 'trust/quality.svg',
            title: 'Высокое качество',
          },
          {
            description: '<span>Круглосуточная</span> поддержка',
            logo: 'trust/support.svg',
            title: 'Поддержка и забота',
          },
        ],
        title: 'Почему Hart Estate доверяют?',
      },
    },
  }),
  methods: {
    scrollToShowcase() {
      this.$router.push({ path: '/' }).then(() => smoothScroll('showcase'));
    },
  },
};
</script>
